import CreateProvider from './create-provider';

export default CreateProvider;
